import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FlatButton from 'material-ui/FlatButton';
import SelectField from 'material-ui/SelectField';
import Paper from 'material-ui/Paper';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import IconMenu from 'material-ui/IconMenu';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import ActionPrint from 'material-ui/svg-icons/action/print';

import _ from 'lodash';

import ReduxDialog from '../Common/ReduxDialog';
import { showDialog, hideDialog, showError } from '../../actions/dialogs';
import { generatePdfLabels, generateZebraLabels } from '../../utils/labels';
import { fetchLabelFormatsRoutine, fetchPrintersRoutine } from '../../routines';
import { toArray, sortByLocation, sortStrings } from '../../utils/helper';

import styles from './styles';

const printZebra = (job, tasks, specification, sheets, embedType, printer, blanks, onError) => {
  if (!printer) {
    onError('Error', 'Printer is not selected');
  }

  return generateZebraLabels(job, tasks, specification, sheets, embedType, blanks)
    .then((labels) => {
      console.log('labels', labels);
      if (printer.connection === 'network' || printer.connection === 'usb') {
        const mapForm = document.createElement('form');
        mapForm.target = 'Map';
        mapForm.method = 'POST'; // or "post" if appropriate

        if (printer.connection === 'network') {
          mapForm.action = 'http://printing.staza.io/zebraprint.php';
        } else {
          mapForm.action = 'http://printing.staza.io/zebrausbprint.php'; // 'http://printing.staza.io/zebrausbprint.php';
        }

        const BATCH_SIZE = 100000000;
        const batches = labels.length / BATCH_SIZE;
        _.range(0, batches).forEach((i) => {
          console.log('adding batch', i);
          const mapInput = document.createElement('input');
          mapInput.type = 'text';
          mapInput.name = `specification`; // ${i}
          mapInput.value = labels.slice(i * BATCH_SIZE, (i + 1) * BATCH_SIZE).join('');
          mapForm.appendChild(mapInput);
        });

        document.body.appendChild(mapForm);

        const map = window.open('', 'Map', 'status=0,title=0,height=400,width=600,scrollbars=0');

        if (map) {
          mapForm.submit();
        } else {
          onError('Error', 'You must allow popups for this map to work.');
        }
      } else {
        onError('Error', `Unknown printer connection type - ${printer.connection}`);
      }

      return 1;
    }).catch((err) => {
      onError('Error', err.message);
    });
};

class GenerateLabels extends React.Component {
  static propTypes = {
    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired,

    fetchLabelFormats: PropTypes.func.isRequired,
    fetchPrinters: PropTypes.func.isRequired,
    labelFormats: PropTypes.array.isRequired,

    tasks: PropTypes.array.isRequired,
    job: PropTypes.object.isRequired,
    printers: PropTypes.object.isRequired,
  };

  state = {
    labelFormats: [],
    // labelFormat: { id: 0 },
    sheets: 8,
    generateMenu: false,
  };

  componentWillMount() {
    this.props.fetchLabelFormats();
    this.props.fetchPrinters();
  }

  handleSelectLabelFormat = (event, index, labelFormatId) => {
    const labelFormat = this.props.labelFormats.find((lf) => lf.id === labelFormatId);
    console.log('handleSelectLabelFormat', index, labelFormatId, labelFormat)
    this.setState({
      labelFormat,
      specification: labelFormat.specification,
      sheets: labelFormat.type === 'zebra' ? 8 : 1,
    });
  };

  handleHideGenerateMenu = (value) => {
    console.log(value);
    this.setState({
      generateMenu: value,
    });
  };

  handleGenerateMenu = (evt, value) => {
    console.log('handleGenerateMenu', value, evt);
    switch (value) {
      case 'test':
        this.handleGenerateTest();
        break;
      case 'blanks':
        this.handleGenerateBlanks();
        break;
      case 'print':
        this.handleGenerate();
        break;
      default:
        break;
    }
  };

  handleGenerate = () => {
    const { showError } = this.props;

    const tasks = this.props.tasks.sort((a, b) => sortByLocation(a.origin, b.origin));

    const embedType = true; // TODO

    if (this.state.labelFormat.type === 'zebra') {
      if (this.state.printer) {
        printZebra(this.props.job, tasks, this.state.specification, this.state.sheets, embedType, this.props.printers[this.state.printer], false, showError)
          .then(this.handleClose);
      } else {
        showError('Error', 'Please select a printer');
      }
    } else {
      this.props.showDialog('loading');
      generatePdfLabels(this.props.job, tasks, this.state.labelFormat, this.state.sheets, embedType)
        .then(() => {
          this.props.hideDialog('loading');
          this.handleClose();
        })
        .catch((err) => {
          this.props.showError('Unable to generate PDF');
          this.props.hideDialog('loading');
        });
    }
  };

  handleGenerateTest = () => {
    const { showError } = this.props;
    const tasks = [this.props.tasks[0]];
    const embedType = true; // TODO

    //job, tasks, specification, sheets, embedType, printer, blanks, onError
    if (this.state.labelFormat.type === 'zebra') {
      if (this.state.printer) {
        printZebra(this.props.job, tasks, this.state.specification, 1, embedType, this.props.printers[this.state.printer], false, showError);
      } else {
        showError('Error', 'Please select a printer');
      }
    } else {
      this.props.showDialog('loading');
      generatePdfLabels(this.props.job, tasks, this.state.labelFormat, this.state.sheets, embedType)
        .then(() => {
          this.props.hideDialog('loading');
        })
        .catch((err) => {
          this.props.showError('Unable to generate PDF');
          this.props.hideDialog('loading');
        });
    }
  };

  handleGenerateBlanks = () => {
    const { showError } = this.props;

    if (this.state.labelFormat.type === 'zebra') {
      if (this.state.printer) {
        printZebra(this.props.job, null, this.state.specification, this.state.sheets, false, this.props.printers[this.state.printer], true, showError);
      } else {
        showError('Error', 'Please select a printer');
      }
    } else {
      this.props.showDialog('loading');
      generatePdfLabels(this.props.job, null, this.state.labelFormat, this.state.sheets, false, true)
        .then(() => {
          this.props.hideDialog('loading');
        })
        .catch((err) => {
          this.props.showError('Unable to generate PDF');
          this.props.hideDialog('loading');
        });
    }
  };

  handleClose = () => {
    this.setState({ labelFormat: null });
    this.props.hideDialog('generateLabels');
  };

  handleCustomizeSpecification = () => {
    this.setState({
      customizeSpecification: true,
      specification: this.state.labelFormat.specification,
    });
  };

  renderLabelFormat(labelFormat) {
    switch (labelFormat.type) {
      case 'zebra':
        return this.renderZebraLabelFormat(labelFormat);
      default:
        return this.renderStandardLabelFormat(labelFormat);
    }
  }

  renderZebraLabelFormat() {
    return (<div>
      <SelectField
        floatingLabelText="Labels Per Task"
        floatingLabelFixed
        value={this.state.sheets}
        onChange={(evt, idx, sheets) => this.setState({ sheets })}
        fullWidth
        style={styles.format}
      >
        { _.range(1, 50).map((i) => <MenuItem
          key={i}
          value={i}
          primaryText={i}/>)}
      </SelectField>
      { this.state.customizeSpecification ? <TextField
        value={this.state.specification}
        onChange={(evt, specification) => this.setState({ specification })}
        multiLine
        rows={8}
        fullWidth/> : <RaisedButton label="Customize Labels..." onClick={this.handleCustomizeSpecification}/>}

    </div>);
  }

  renderStandardLabelFormat(labelFormat) {
    const layout = labelFormat.layout;

    return (
      <div>
        <SelectField
          floatingLabelText="Sheets Per Task"
          floatingLabelFixed
          value={this.state.sheets}
          onChange={(evt, idx, sheets) => this.setState({ sheets })}
          fullWidth
          style={styles.format}
        >
          { _.range(1, 5).map((sheets) => <MenuItem
            key={sheets}
            value={sheets}
            primaryText={sheets}/>)}
        </SelectField>

        <Paper style={styles.paper}>
          <table>
            <tbody>
            <tr>
              <td style={styles.header} width="60%">Rows</td>
              <td width="20%"></td>
              <td style={styles.layoutValue} width="20%">{layout.rows}</td>
            </tr>
            <tr>
              <td style={styles.header}>Columns</td>
              <td></td>
              <td style={styles.layoutValue}>{layout.columns}</td>
            </tr>
            <tr>
              <td style={styles.header}>Label Width</td>
              <td></td>
              <td style={styles.layoutValue}>{layout.label.width}</td>
            </tr>
            <tr>
              <td style={styles.header}>Label Height</td>
              <td></td>
              <td style={styles.layoutValue}>{layout.label.height}</td>
            </tr>
            <tr>
              <td style={styles.header}>Margins</td>
              <td>Top</td>
              <td style={styles.layoutValue}>{layout.sheet.margins.top.toFixed(2)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Left</td>
              <td style={styles.layoutValue}>{layout.sheet.margins.left.toFixed(2)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Right</td>
              <td style={styles.layoutValue}>{layout.sheet.margins.right.toFixed(2)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Bottom</td>
              <td style={styles.layoutValue}>{layout.sheet.margins.bottom.toFixed(2)}</td>
            </tr>
            <tr>
              <td style={styles.header}>Internal Horizontal Spacing</td>
              <td></td>
              <td style={styles.layoutValue}>{layout.internal.horizontal.toFixed(2)}</td>
            </tr>
            <tr>
              <td style={styles.header}>Internal Vertical Spacing</td>
              <td></td>
              <td style={styles.layoutValue}>{layout.internal.vertical.toFixed(2)}</td>
            </tr>
            </tbody>
          </table>
        </Paper>
      </div>);
  }

  renderLabelImage(labelFormat) {
    return (
      <img src={`https://s3.amazonaws.com/assets.staza.io/labelformats/labels_${labelFormat.key}.jpg`} height={300} alt="Label Format"/>);
  }

  render() {
    const { printers } = this.props;
    const { labelFormat } = this.state;

    const count = this.props.tasks.length * this.state.sheets;
    let exceedingLimits = false;
    let printLabel = 'Generate';
    let blanksLabel = 'Print Blanks';

    if (labelFormat) {
      switch (labelFormat.type) {
        case 'zebra':
          printLabel = `Print (${count} Labels)`;
          blanksLabel = `Print Blanks (${this.state.sheets} Labels)`;
          break;
        default:
          printLabel = `Generate (${count} Sheets)`;
          blanksLabel = `Generate Blanks (${this.state.sheets} Sheets)`;
          exceedingLimits = count > 100;
          break;
      }
    }

    const actions = [
      <FlatButton
        label="Close"
        onClick={this.handleClose}
      />,
      <span>
        <IconMenu
          iconButtonElement={<IconButton><ActionPrint /></IconButton>}
          open={this.state.generateMenu}
          onRequestChange={this.handleHideGenerateMenu}
          onChange={this.handleGenerateMenu}
          disabled={!this.state.labelFormat}
        >
          <MenuItem value="test" primaryText="Test Print" disabled={exceedingLimits || !this.state.labelFormat || _.keys(this.props.tasks).length === 0}/>
          <MenuItem value="blanks" primaryText={blanksLabel}
                    disabled={exceedingLimits || !this.state.labelFormat} />
          <MenuItem value="print" primaryText={printLabel}
                    disabled={exceedingLimits || !this.state.labelFormat || _.keys(this.props.tasks).length === 0}/>
        </IconMenu>
        <FlatButton onClick={() => this.setState({ generateMenu: true })} label="Generate"/>
      </span>
    ];

    return (
      <ReduxDialog
        name="generateLabels"
        title="Generate Labels"
        actions={actions}
        bodyStyle={styles.body}
      >
        { exceedingLimits ? <Paper style={styles.exceedingLimits}><FontIcon className="material-icons" style={styles.warningIcon}>warning</FontIcon> You can only generate 50 sheets when choosing a conventional label type/printer option. Using a Zebra printer is not capped</Paper> : null }
        <div style={styles.row}>
          <div style={styles.column}>
            <SelectField
              floatingLabelText="Label Format"
              floatingLabelFixed
              value={labelFormat ? labelFormat.id : null}
              onChange={this.handleSelectLabelFormat}
              fullWidth
              style={styles.format}
            >
              { this.props.labelFormats.map((format) => <MenuItem
                key={format.id}
                value={format.id}
                primaryText={format.name}/>)}
            </SelectField>

            { labelFormat && labelFormat.type === 'zebra' ? <SelectField
              floatingLabelText="Printer"
              floatingLabelFixed
              value={this.state.printer}
              onChange={(evt, idx, printer) => this.setState({ printer })}
              fullWidth
              style={styles.format}
            >
              { toArray(printers).map((printer) => <MenuItem
                key={printer.id}
                value={printer.id}
                primaryText={printer.name} />)}
            </SelectField> : null }

            {labelFormat ? this.renderLabelFormat(labelFormat) : null}
          </div>

          {labelFormat ? this.renderLabelImage(labelFormat) : null}
        </div>
      </ReduxDialog>
    );
  }
}

function mapStateToProps(state) {
  return {
    job: state.get('jobs').get('job').toJS(),
    labelFormats: toArray(state.get('labelformats').get('labelFormats').toJS()).sort((a, b) => sortStrings(a.name, b.name)),
    tasks: state.getIn(['dialogs', 'dialogs', 'generateLabels', 'context', 'tasks']).toJS(),
    printers: _.pickBy(state.get('printers').get('printers').toJS(), (printer) => !printer.deleted),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchLabelFormats: fetchLabelFormatsRoutine.trigger,
    fetchPrinters: fetchPrintersRoutine.trigger,
    showDialog,
    hideDialog,
    showError,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GenerateLabels);



// WEBPACK FOOTER //
// ./src/components/GenerateLabelsDialog/index.js